var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"textContainer",staticClass:"text-wrap-pretty",class:{ 'single-line': _vm.isSingleLine, 'truncate-text': !_vm.isSingleLine }},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }